/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Created for Universe App Tools.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.agreement",
  title: "Agreement",
  description: "A checkbox that represents an agreement.",
  control: true,
  preview: "ua.preview.agreement",
  prevalidate: true,
  supportServer: false,
  fields: {
    "name": {
      title: "Name",
      type: "string",
      description: "The name of the control.",
      required: true
    },
    "title": {
      title: "Title",
      type: "string",
      description: "The title of the control.",
      required: true
    },
    "icon": {
      title: "Icon",
      type: "string",
      description: "The icon of the control.",
      required: false
    },
    "agreement": {
      title: "Agreement",
      type: "date",
      description: "The agreement date.",
      addtouae: true
    },
    "inner": {
      title: "Inner",
      type: "inner",
      description: "The inner content of the agreement.",
      required: true
    }
  },
  passthrough: {
    except: ["checked", "type", "id"]
  }
});
// var namespace = module.exports.namespace;

var jsonRender = require("../interface/jsonRender.js");
var uai = require("../interface/interface.js");

// var define = {
//   namespace: "ua.agreement",
//   title: "Agreement",
//   description: "A checkbox that represents an agreement.",
//   control: true,
//   prevalidate: true,
//   supportServer: false,
//   fields: {
//     "name": {
//       type: "string",
//       description: "The name of the control.",
//       required: true
//     },
//     "title": {
//       type: "string",
//       description: "The title of the control.",
//       required: true
//     },
//     "icon": {
//       type: "string",
//       description: "The icon of the control.",
//       required: false
//     },
//     "agreement": {
//       type: "date",
//       description: "The agreement date.",
//       addtouae: true
//     },
//     "inner": {
//       type: "inner",
//       description: "The inner content of the agreement.",
//       required: true
//     }
//   },
//   passthrough: {
//     except: ["checked", "type", "id"]
//   }
// }; 
// module.exports.define = define;

exports.render = async function (options) {

  var randomName = uai.generateRandomID(24);
//   var checkedAttribute = options.checked ? "checked" : "";

  var element = {
    "n": "div",
    "name": options.name,
    "c": "form-group pb-3",
    "i": [{
      "n": "div",
      "c": "form-check",
      "i": [{
        "n": "input",
        "type": "checkbox",
        "class": "form-check-input",
        "id": randomName,
        // "checked": checkedAttribute
      }, {
        "n": "label",
        "for": randomName,
        "c": "form-check-label",
        "i": options.title
      }]
    }, {
      "n": "div",
      "c": "pb-3 form-agreement",
      "i": options.inner
    }]
  };


  if ("agreement" in options) {
    //is agreement a valid date
    if (Date.parse(options.agreement)) {

      //check the box
      element.i[0].i[0].checked = true;

      element.i[1].i.push({
        "n": "p",
        "c": "form-agreement-date",
        "i": "Agreed on: " + options.agreement
      });

    }

  }

  if ("required" in options) {
    element.i[0].i[0].required = options.required;
  }
 
  if ("icon" in options) {
    element.i[0].i.unshift({
      "n": "i",
      "class": options.icon + " form-check-icon"
    });
  }

  var domElement = await jsonRender.render(element);
  
  // Event listeners
  var inputElement = domElement.querySelector('input');
  // inputElement.addEventListener("focus", focus);
  // inputElement.addEventListener("focusout", focus);
  inputElement.addEventListener("change", (event) => {
    setTimeout(() => {
      focus(event);
    }, 100);
  });

  return domElement;
}

function focus(event) {
  var input = event.target;
  input.classList.remove("is-invalid");
  input.classList.remove("is-valid");
  if (input.checked !== input.defaultChecked) {
    input.classList.add("is-valid");
  } else {
    input.classList.add("is-invalid");
  }
}

function validation(control) {
  var input = control.querySelector("input");
  var errors = [];
  if (!input.checkValidity()) {
    errors.push({
      type: "validation",
      message: input.validationMessage
    });
  }
  return errors;
}

async function save(name, control, repo) {
  console.log("Saving Agreement", {
    name,
    control,
    repo
  });

  var input = control.querySelector("input");
  repo.errors = validation(control);
  repo.success = repo.errors.length === 0;

  //get the date of the agreement control.getAttribute
  var agreementDate = control.getAttribute("agreement");

  //is it a valid date?
  if (Date.parse(agreementDate)) {
    repo.data = { checked: input.checked, agreement: agreementDate };
  } else {
    repo.data = { checked: input.checked, agreement: false };
  }

  //if the checkbox is no longer checked remove the date
  if (!input.checked) {
    delete repo.data.agreement;
    control.querySelector(".form-agreement-date").remove();
    control.removeAttribute("agreement");
  }

  repo.data = { checked: input.checked };
  return repo;
}

async function load(name, control, data) {
  var input = control.querySelector("input");
  input.checked = data.checked;
}

module.exports.save = save;
module.exports.load = load;